import { render, staticRenderFns } from "./DocumentRuleManager.vue?vue&type=template&id=5d8a3952&scoped=true&"
import script from "./DocumentRuleManager.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleManager.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRuleManager.vue?vue&type=style&index=0&id=5d8a3952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a3952",
  null
  
)

export default component.exports